module.exports = __webpack_public_path__ + "img/card.9f90c311.svg";